import Sidebar from '../components/Sidebar.jsx'
import PageHeader from '../components/PageHeader.jsx'
import { Link } from 'react-router-dom';

import '../styles/fonts.css';

let sections = [
    { id: 's3', name: 'SDG Goal 3 Good Health and Well-being' },
    { id: 's4', name: 'SDG Goal 4 Quality Education  ' },
    { id: 's11', name: 'SDG Goal 11: Sustainable Cities and Communities' },
    { id: 's12', name: 'SDG Goal 12: Responsible consumption and production' },
    { id: 's13', name: 'SDG Goal 13: Climate Action' }
];

const SDGs = () => {
    let sampleImg = 'https://static.igem.wiki/teams/5066/global/bgpic.png';

    return (
        <div>
            <div className='bg-[#d9eaf0]'>
                <PageHeader img={sampleImg} title='SDGs' />
            </div>
            <div className='flex bg-gradient-to-b from-[#d9eaf0] via-[#e8f3f7] to-[#feedfb]'>

                <Sidebar sections={sections} />

                {/* Main Content */}
                <div className='flex-col w-full lg:p-[50px] p-[5px] my-[10px] space-y-16 rounded-2xl bg-[#fffdf2] shadow-[-2px_4px_8px_-2px_rgba(0,0,0,0.2)]'>

                    <div className='pb-4 '>
                        <section id='s3'>
                            <img
                                src='https://static.igem.wiki/teams/5066/human-practice/sdgnew.png'
                                alt='Team'
                                className='w-[80%] h-auto pt-4'
                            />
                        </section>
                    </div>

                    <div className='pb-12'>
                        <section id='s4'>
                            <div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
                                <span className='text-gray-800 font-bold'></span>
                            </div>
                            <h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
                                SDG Goal 3 Good Health and Well-being
                            </h2>
                            <div className='mt-4'>
                                <p className='mt-2 text-gray-700 leading-relaxed'>
                                    Within its specifications, we contribute to goal 3.3: Fight communicable diseases stating “By 2030, end the epidemics of AIDS, tuberculosis, malaria and neglected tropical diseases and combat hepatitis, water-borne diseases and other communicable diseases.” We hope to provide a sustainable and effective solution to better combat dengue fever. Our
                                    <Link
                                        to="/hardware"
                                        state={{tab: 'tab1', to: 's5'}}
                                        className="text-[#C94C67] underline font-bold hover:text-[#b43852]"
                                    > sticky oviTrap </Link> (Details shown in Hardware → Our Solution + Design of the Beeter Trap) 
                                    is designed specifically to target  <span className='italic'>Aedes</span> mosquitoes, offering a practical and environmentally friendly approach to vector control. By effectively reducing the number of these disease-carrying mosquitoes, we aim to play a vital role in ending the dengue epidemic in cities as well as rural areas. This initiative not only aligns with global health goals but also underscores our commitment to creating safer communities through sustainable practices.
                                </p>
                            </div>
                        </section>
                    </div>

                    <div className='pb-12'>
                        <section id='s11'>
                            <div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
                                <span className='text-gray-800 font-bold'></span>
                            </div>
                            <h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
                                SDG Goal 4 Quality Education
                            </h2>
                            <p className='mt-2 text-gray-700 leading-relaxed'>
                                The initiatives to educate various age groups about synthetic biology and dengue fever align closely with Sustainable Development Goal 4 (SDG 4), which aims to ensure inclusive and equitable education and promote lifelong learning opportunities for all. By targeting preschool, elementary, middle, and high school students, the program addresses the need for quality education across different developmental stages, fostering a foundational understanding of critical scientific concepts and public health issues.
                            </p>
                            <p className='mt-2 text-gray-700 leading-relaxed'>
                                <Link
                                    to="/Education"
                                    className="text-[#C94C67] underline font-bold hover:text-[#b43852]"
                                >
                                    The outreach
                                </Link> (Details shown in Education → Education Outreach) includes interactive teaching materials tailored to each age group's specific needs, emphasizing the importance of quality learning environments as outlined in SDG 4.
                            </p>
                            <p className='mt-2 text-gray-700 leading-relaxed'>
                                <ul className='list-disc space-y-5 pl-8'>
                                    <li>
                                        <strong>Preschoolers: </strong>Storytelling through a storybook raises awareness about dengue, complemented by drawing activities and a fun card game to reinforce knowledge.
                                    </li>
                                    <li>
                                        <strong>Elementary Level: </strong>Hands-on activities merge simple genetic concepts using toy blocks to illustrate code pairing, alongside engaging videos and interactive Q&A games about dengue.
                                    </li>
                                    <li>
                                        <strong>Junior High and High School: </strong>Students explore practical uses of synthetic biology and discuss ethical concerns, promoting dialogue and cultivating interest in the field.
                                    </li>
                                </ul>
                            </p>
                            <p className=' text-gray-700 leading-relaxed pt-4'>
                                Furthermore, the community event <Link
                                    to="/education#s3"
                                    className="text-[#C94C67] underline font-bold hover:text-[#b43852]"
                                >
                                    "Dengue Day"
                                </Link>  (Details shown in Education → Dengue Day) to educate the general public about dengue fever prevention, promoting lifelong learning opportunities beyond formal education. This initiative encourages public participation in health discussions, aligning with SDG 4's objective to provide accessible education for all community members.
                            </p>
                            <p className='mt-2 text-gray-700 leading-relaxed'>
                                We also emphasized
                                <Link
                                    to="/Education"
                                    className="text-[#C94C67] underline font-bold hover:text-[#b43852]"
                                > inclusivity </Link> (Details shown in Human Practice → Inclusivity) includes interactive teaching materials tailored to each age group's specific needs, emphasizing the importance of quality learning environments as outlined in SDG 4.
                                for visually impaired individuals by creating accessible educational materials such as braille books and audiobooks. Customized lessons ensure that vulnerable populations receive quality education, demonstrating a commitment to addressing educational disparities—a core tenet of SDG 4.
                            </p>
                        </section>
                    </div>

                    <div className='pb-12'>
                        <section id='s12'>
                            <div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
                                <span className='text-gray-800 font-bold'></span>
                            </div>
                            <h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
                                SDG Goal 11: Sustainable Cities and Communities
                            </h2>
                            <p className='mt-2 text-gray-700 leading-relaxed'>
                                While our primary focus lies in combating communicable diseases like dengue fever, our efforts also contribute significantly to Goal 11 of the United Nations Sustainable Development Goals: "Make cities and human settlements inclusive, safe, resilient and sustainable." Our approach to vector control is relatively sustainable as
                                <Link
                                    to="/wetlab"
                                    className="text-[#C94C67] underline font-bold hover:text-[#b43852]"
                                > our toxins </Link>
                                (link to wetlab Cyt2Ba page) are environmentally friendly. By providing a sustainable and effective solution to control the population of <span className='italic'>Aedes</span> mosquitoes, the primary vectors of dengue virus, we are actively working towards creating safer and healthier urban environments.
                            </p>
                        </section>
                    </div>

                    <div className='pb-12'>
                        <section id='s13'>
                            <div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
                                <span className='text-gray-800 font-bold'></span>
                            </div>
                            <h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
                                SDG Goal 12: Responsible Consumption and Production
                            </h2>
                            <p className='mt-2 text-gray-700 leading-relaxed'>
                                Our gravitrap initiative aligns with SDG Goal 12: Responsible Consumption and Production by promoting the use of recycled materials in our products and reducing waste through innovative recycling methods. A key component of our strategy is the
                                <Link
                                    to="/Education"
                                    className="text-[#C94C67] underline font-bold hover:text-[#b43852]"
                                > Penny trap </Link>
                                (Details shown in Education → Promotion→ Social Media) initiative, where we teach communities how to make affordable dengue traps using recycled plastics and repurposed household items. This approach empowers people to take an active role in dengue prevention while minimizing waste and promoting responsible consumption.                            </p>
                            <p className='mt-2 text-gray-700 leading-relaxed pt-4'>
                                Some key aspects of the Pennytrap initiative include:
                            </p>
                            <p className='mt-2 text-gray-700 leading-relaxed'>
                                <ul className='list-disc space-y-3 pl-8'>
                                    <li>
                                        Using recycled plastics and repurposed containers to create effective dengue traps
                                    </li>
                                    <li>
                                        Providing educational workshops and training programs to teach people how to make Pennytraps
                                    </li>
                                    <li>
                                        Collaborating with NGOs and local organizations to distribute Pennytrap kits and resources
                                    </li>
                                    <li>
                                        Encouraging sustainable practices and responsible consumption at the community level
                                    </li>
                                </ul>
                            </p>
                        </section>
                    </div>

                    <div classsName='pb-12'>
                        <section id='s6'>
                            <div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
                                <span className='text-gray-800 font-bold'></span>
                            </div>
                            <h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
                                SDG Goal 13: Climate Action
                            </h2>
                            <p className='mt-2 text-gray-700 leading-relaxed'>
                                Our project aligns with both Goal 13: "Build knowledge and capacity to meet climate change" and "Promote mechanisms to raise capacity for planning and management." Through our engaging
                                <Link
                                    to="/Education"
                                    className="text-[#C94C67] underline font-bold hover:text-[#b43852]"
                                > "Weekly Dose of Bryan" </Link>
                                (Details shown in Education → Promotion→ Social Media) videos, we provide valuable education on how synthetic biology can reduce the carbon footprint. Additionally, we highlight innovative uses of materials such as beetroot peels from food waste and recycled plastics in the creation of our Penny trap.
                            </p>
                            <p className='mt-2 text-gray-700 leading-relaxed'>
                                By integrating sustainable practices into city planning, we enhance public spaces and contribute to a healthier standard of living.
                            </p>
                        </section>
                        <h1 className='mt-8 font-bold text-2xl text-[#C94C67]'>Reference</h1>
                        <p className='mt-2 text-gray-600'>
                            [1] Goals archive. (2021, September 17). The Global Goals. https://www.globalgoals.org/goals/
                        </p>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default SDGs;
